import React, { createContext, useContext, useEffect, useState } from 'react';
import ApiService from 'services/ApiService';
import { repeatEffect, settingsConfig } from 'utils/commonFunc';

const TrafficTotalContext = createContext(null);

export function SwItsGetDangerVehicleProvider({ children }) {
  const [currentData, setCurrentData] = useState();

  useEffect(() => {
    return repeatEffect(async () => {
      const response = await ApiService.get('newdashboard/trfsfty/GetDangerVehicle');
      if (response.status === 200) {
        const data = response.data;

        setCurrentData({
          updateTime: data.updateTime,
          gsVehicleValue: data.rows[0].gsCnt, // 고압가스
          dgVehicleValue: data.rows[0].dgCnt, // 휘발유
          chVehicleValue: data.rows[0].chCnt, // 폭발물 (화학물질)
          wsVehicleValue: data.rows[0].wsCnt, // 폐기물
          etcVehicleValue: data.rows[0].etcCnt // etc
        });
      }
    }, settingsConfig().contentUpdateDelaySec);
  }, []);

  return <TrafficTotalContext.Provider value={currentData}>{children}</TrafficTotalContext.Provider>;
}

export function SwItsDangerVehicleTotalInfo() {
  const currentData = useContext(TrafficTotalContext);
  if (!currentData) return null;
  const etcVal = currentData.wsVehicleValue + currentData.etcVehicleValue;
  return (
    <div className="fgrWrap flx a_center j_spc_btw">
      <div className="fgrBox innerBg flx flx_col j_center a_center">
        <p>가스</p>
        <div className='flx a_flx_end'>
          <p className="fgr" style={{ color: '#FF9826' }}>
            {currentData.gsVehicleValue?.toLocaleString()}
          </p>
          <p className='unit'>대/시</p>
        </div>
      </div>
      <div className="fgrBox innerBg flx flx_col j_center a_center">
        <p>유해화학물질</p>
        <div className='flx a_flx_end'>
          <p className="fgr" style={{ color: '#E4C200' }}>
            {currentData.chVehicleValue?.toLocaleString()}
          </p>
          <p className='unit'>대/시</p>
        </div>
      </div>
      <div className="fgrBox innerBg flx flx_col j_center a_center">
        <p>위험물질</p>
        <div className='flx a_flx_end'>
          <p className="fgr" style={{ color: '#DF2B2A' }}>
            {currentData.dgVehicleValue?.toLocaleString()}
          </p>
          <p className='unit'>대/시</p>
        </div>
      </div>
      <div className="fgrBox innerBg flx flx_col j_center a_center">
        <p>폐기물</p>
        <div className='flx a_flx_end'>
          <p className="fgr" style={{ color: '#FF3F9C' }}>
            {etcVal?.toLocaleString()}
          </p>
          <p  className='unit'>대/시</p>
        </div>
      </div>
    </div>
  );
}
